import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLogoutUserMutation } from 'src/reduxStore/reduxToolkitQuery'
import { deleteAdminToken } from 'src/reduxStore/slices/generalSlice'
import { CONSTANTS } from 'src/reduxStore/reduxToolkitQuery'
import * as _ from 'lodash'

const IdleLogout = (props) => {
  const dispatch = useDispatch()
  const timeOutValue = useSelector((state) => state.general.timeOutValue)
  const [intervalReference, setIntervalReference] = useState()
  const [logoutUser] = useLogoutUserMutation()
  const idleLogoutCheckHandler = () => {
    startTimer()
  }
  const startTimer = () => {
    if (intervalReference) {
      clearTimeout(intervalReference)
    }
    if (_.includes(CONSTANTS.ROUTES, window.location.pathname)) {
      setIntervalReference(
        setTimeout(async function () {
          try {
            if (localStorage.getItem('authToken') != null) {
              const response = await logoutUser().unwrap()
              if (response) {
                dispatch(deleteAdminToken())
                window.location.pathname = '/login'
              }
            }
          } catch (err) {
            console.log('ERROR DURING LOGOUT', err)
          }
        }, timeOutValue),
      )
    }
  }
  useEffect(() => {
    startTimer()
  }, [])
  return <div onMouseOver={idleLogoutCheckHandler}>{props.children}</div>
}
export default IdleLogout
